import {ChessPiece} from "./chessPiece";
import {PAWN_BLACK, PAWN_WHITE} from "./svg";

export class Pawn extends ChessPiece {
    initialLine = 1;
    name = 'pawn';

    svgBlack = PAWN_BLACK;
    svgWhite = PAWN_WHITE;

    positionsUnderAttack(board) {
        let result;
        if (this.direction[0]) {
            result = [[this.posX + this.direction[0], this.posY - 1], [this.posX + this.direction[0], this.posY + 1]];
        } else {
            result = [[this.posX - 1, this.posY + this.direction[1]], [this.posX + 1, this.posY + this.direction[1]]];
        }
        result = result.filter(pos => {
            return pos[0] >= 0 && pos[0] < board.scaleX && pos[1] >= 0 && pos[1] < board.scaleY
        });
        return result;
    }

    availablePositions(board) {
        let attack = this.positionsUnderAttack(board);
        let result = [];
        const pieceForward = board.getPiece(this.posX + this.direction[0], this.posY + this.direction[1]);
        if (!pieceForward) {
            result.push([this.posX + this.direction[0], this.posY + this.direction[1]]);
            if ((this.direction[0] && this.initialLine === this.posX) || (this.direction[1] && this.initialLine === this.posY)) {
                const farPiece = board.getPiece(this.posX + this.direction[0] * 2, this.posY + this.direction[1] * 2);
                if (!farPiece) {
                    result.push([this.posX + this.direction[0] * 2, this.posY + this.direction[1] * 2]);
                }
            }
        }
        attack.forEach(pos => {
            const piece = board.getPiece(pos[0], pos[1]);
            if (piece && piece.player !== this.player) {
                result.push(pos);
            } else {
                const enPassantPawn = this.getEnPassantPawn(board, pos[0], pos[1]);
                if (enPassantPawn) {
                    result.push(pos);
                }
            }
        });
        result = result.filter(pos => {
            return !this.isCheckAfterMove(board, pos)
        });
        return result;
    }

    getEnPassantPawn(board, attackX, attackY) {
        let move;
        if (board.history.historyMove != null) {
            move = board.history.moves[board.history.historyMove - 1];
        } else {
            move = board.history.moves[board.history.currentMove];
        }
        if (move) {
            const piece = board.getPiece(move.to[0], move.to[1]);
            if (piece.name === this.name && piece.player !== this.player) {
                const isLinear = move.from[0] === move.to[0] || move.from[1] === move.to[1];
                const isJump = Math.abs(move.from[0] - move.to[0] + move.from[1] - move.to[1]) === 2;
                if (isLinear && isJump) {
                    const middleX = (move.from[0] + move.to[0]) / 2;
                    const middleY = (move.from[1] + move.to[1]) / 2;
                    if (middleX === attackX && middleY === attackY) {
                        return piece;
                    }
                }
            }
        }
    }

    beforeMove(board, x, y) {
        super.beforeMove(board, x, y);
        const enPassantPawn = this.getEnPassantPawn(board, x, y);
        if (enPassantPawn) {
            board.deletePiece(enPassantPawn);
        }
    }

    clone() {
        const result = new Pawn();
        super.clone(result);
        result.initialLine = this.initialLine;
        return result;
    }
}